import { CheckCircleFilled, CoffeeOutlined } from "@ant-design/icons";
import { Flex, Modal, Typography, theme, App } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const CustomerPortalModal = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const { modal } = App.useApp();

  const handleOk = () => {
    setOpen(false);
    modal.success({
      icon: null,
      closable: true,
      centered: true,
      footer: null,
      content: (
        <Flex gap={8} vertical align="center">
          <CheckCircleFilled
            style={{ color: token.colorSuccess, fontSize: "4em", marginBottom: token.marginSM }}
          />
          <Typography.Title level={4} style={{ margin: 0 }}>
            {t("activerecord.attributes.layout.onboarding.thank_you.title")}
          </Typography.Title>
          <Typography.Text type="secondary" style={{ margin: 0 }}>
            {t("activerecord.attributes.layout.onboarding.thank_you.content")}
          </Typography.Text>
        </Flex>
      ),
    });
  };

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        onClick={handleOpen}
      ></div>
      <Modal
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        onOk={handleOk}
        okText={t("activerecord.attributes.layout.onboarding.early_access.action")}
        okButtonProps={{
          id: "mixpanel-early-access",
        }}
        closable={false}
        title={
          <Flex gap={8}>
            <CoffeeOutlined style={{ color: token.blue }} />
            <Typography.Title level={5}>
              {t("activerecord.attributes.layout.onboarding.early_access.title")}
            </Typography.Title>
          </Flex>
        }
      >
        {t("activerecord.attributes.layout.onboarding.early_access.content")}
      </Modal>
    </>
  );
};

export default CustomerPortalModal;
